import { useAppDispatch, useAppSelector } from 'src/hooks/store';
import { modalSelector } from 'src/state/selectors/modal';
import { hideModal } from 'src/state/slices/modal';
import { Button } from '@odekoteam/doppio';

const CancelButton = ({
  variant = 'ghost',
  returnFocusId,
  isDisabled = false,
}: {
  variant?: 'primary' | 'secondary' | 'tertiary' | 'ghost' | 'slay';
  // Id of the control that opened the dialog. A dialog claiming
  // aria-modal="true" has to hand focus back when it closes, or a keyboard user
  // is dropped at the top of the page. Optional: callers whose opener is gone by
  // the time the dialog closes leave it unset.
  returnFocusId?: string;
  // For dialogs that own a write: cancelling mid-flight closes this dialog
  // while the request stays live, and the request's own success then hides
  // whatever dialog has taken its place.
  isDisabled?: boolean;
} = {}): JSX.Element | null => {
  const { dismissButtonLabel } = useAppSelector(modalSelector);
  const dispatch = useAppDispatch();

  const handleOnClickCancel = (): void => {
    dispatch(hideModal());
    if (returnFocusId) document.getElementById(returnFocusId)?.focus();
  };

  return (
    <Button
      id="confirmation-modal-dismiss-button"
      variant={variant}
      isDisabled={isDisabled}
      onPress={handleOnClickCancel}
    >
      {dismissButtonLabel}
    </Button>
  );
};
export default CancelButton;
